
export default function WhyChooseUs() {
  const reasons = [
    {
      icon: 'ri-shield-star-line',
      title: 'Lifetime Warranty',
      description: 'We stand behind our work with comprehensive lifetime warranties on parts and labor for qualifying installations and repairs.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Expert Technicians',
      description: 'Our team consists of highly trained, licensed, and certified professionals with years of experience in the Florida market.'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Upfront Pricing',
      description: 'No hidden fees or surprises. We provide clear, transparent pricing before any work begins, so you know exactly what to expect.'
    },
    {
      icon: 'ri-time-line',
      title: 'On-Time Service',
      description: 'We respect your time. Our technicians arrive on schedule and complete work efficiently without compromising quality.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Availability',
      description: 'Home emergencies don\'t wait for business hours. We\'re available around the clock to handle your urgent service needs.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Energy Efficient',
      description: 'We specialize in energy-efficient solutions that reduce your utility bills while keeping your home comfortable year-round.'
    }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B3A6B] mb-6">
              Why Florida Homeowners Choose Voltis
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              For over a decade, Voltis has been Florida's trusted partner for home comfort and safety. We combine expert craftsmanship with exceptional customer service to deliver results that exceed expectations.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Whether you need routine maintenance, emergency repairs, or complete system installations, our team is committed to providing the highest quality service at competitive prices. We treat every home as if it were our own.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center">
                  <i className="ri-award-fill text-2xl text-[#B22234]"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-[#1B3A6B]">10,000+</p>
                  <p className="text-sm text-gray-600">Happy Customers</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center">
                  <i className="ri-star-fill text-2xl text-[#B22234]"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-[#1B3A6B]">4.9/5</p>
                  <p className="text-sm text-gray-600">Average Rating</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-[#1B3A6B]/10 rounded-full flex items-center justify-center">
                  <i className="ri-calendar-check-fill text-2xl text-[#B22234]"></i>
                </div>
                <div>
                  <p className="text-2xl font-bold text-[#1B3A6B]">15+ Years</p>
                  <p className="text-sm text-gray-600">In Business</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://static.readdy.ai/image/73df10f1d2f13e308059e9f42ef7d721/db862031a24520c6af8a2dbc9d2543f9.png"
                alt="Voltis professional technician team in Florida"
                title="Expert Voltis Service Team"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-[#B22234] text-white p-6 rounded-xl shadow-xl">
              <p className="text-3xl font-bold">100%</p>
              <p className="text-sm">Satisfaction Guaranteed</p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reasons.map((reason, index) => (
            <div key={index} className="bg-[#F8F9FC] rounded-xl p-6 hover:bg-white hover:shadow-lg transition-all duration-300 border border-[#1B3A6B]/10">
              <div className="w-14 h-14 bg-[#1B3A6B] rounded-lg flex items-center justify-center mb-4">
                <i className={`${reason.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1B3A6B] mb-3">{reason.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
